import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

import { ReactComponent as Cancel } from "../../../../Assets/Image/svg/cancel.svg";
import { BtnPrimary } from "../../../share/buttons/Btn";
import MessageQuill from "../../Message/MessageQuill";
import useFetch from "../../../../Hooks/useFetch";
import { useCreate } from "../../../../Context/CreateContext";

const QAInfo = ({ close, status, id, get, setId }) => {
    const { phaseStatus, setPhaseStatus, bootCamp } = useCreate();

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const [call, setCall] = useState();
    const [question, setQuestion] = useState({
        id: "",
        faq_question: "",
        faq_answer: "",
    });

    const closeModal = (e) => {
        e.stopPropagation();
        close();
        setQuestion({
            id: "",
            faq_question: "",
            faq_answer: "",
        });
        setId("");
    };

    const submitForm = () => {
        if (id) {
            editFAQ.reFetch();
            //TODO : pak kardane modal bad az patch
            close();
        } else {
            const formData = new FormData();

            formData.append("bootcamp", bootCamp.id);
            formData.append("faq_question", question.faq_question);
            formData.append("faq_answer", question.faq_answer);

            setCall(formData);
            id ? editFAQ.reFetch() : newFAQ.reFetch();

            setQuestion({
                id: "",
                faq_question: "",
                faq_answer: "",
            });
            close();
        }
    };

    const newFAQ = useFetch({
        method: "POST",
        url: `BootCampFaqService`,
        noHeader: false,
        caller: get,
        trigger: false,
        data: call,
    });

    const editFAQ = useFetch({
        method: "PATCH",
        url: `BootCampFaqService/${id}`,
        noHeader: false,
        caller: get,
        data: question,
    });

    const getFAQId = useFetch({
        method: "GET",
        url: `BootCampFaqService/${id}`,
        noHeader: false,
        trigger: false,
        setter: setQuestion,
    });

    useEffect(() => {
        if (id) {
            getFAQId.reFetch();
        }
    }, [id]);

    useEffect(() => {
        id && editFAQ.reFetch();
    }, [id]);

    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={closeModal}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            <h3 className=" text-center text-[#77498F] text-[20px] font-bold mb-20">
                ساخت سوال متداول
            </h3>
            <form onSubmit={handleSubmit(submitForm)}>
                <input
                    register={{
                        required: {
                            value: true,
                            message: "Enter Name",
                        },
                    }}
                    value={question.faq_question}
                    onChange={(e) =>
                        setQuestion({
                            ...question,
                            faq_question: e.target.value,
                        })
                    }
                    type="text"
                    name="name"
                    control={control}
                    placeholder="متن سوال"
                    className="input border-gray h-[6.4rem] w-full bg-white-dark placeholder-gray text-[1.8rem] pl-[1.4rem] pr-[1.4rem] rounded-[1.5rem] mb-[1.6rem]"
                />

                <MessageQuill
                    placeholder="توضیحات *"
                    value={question.faq_answer}
                    setValue={(e) =>
                        setQuestion({
                            ...question,
                            faq_answer: e,
                        })
                    }
                />

                <div className="flex gap-48 self-end">
                    <BtnPrimary
                        className=" py-[20px] px-[81px] mr-auto"
                        text="ثبت سوال"
                        type="submit"
                    />
                </div>
            </form>
        </div>
    );
};

export default QAInfo;
